/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import {
  StyledBundleContainer,
  StyledAddonContainer,
  StyledSectionItemContainer,
  StyledSectionItemMain,
} from './MenuItem.styles';
import { useGetBreakpoint } from '../../../../modules/utils';
import clsx from 'clsx';
import {
  addonItem,
  allergenType,
  dietType,
  itemBundle,
  packageBundle,
  sectionBundle,
  sectionItem,
  sectionDescriptionLimit,
  sectionNameMenuLimit,
} from '../../../../modules/utils/constants';
import DietAllergenIcon from '../DietAllergenIcon/DietAllergenIcon';
import { Allergen, Diet, MenuItemTypes } from './MenuItem.types';

// This component can be used to render Bundle Item or Section Item or Addons
export const MenuDetailsItem = (props: MenuItemTypes) => {
  let portSize = useGetBreakpoint();
  const [isMobileViewPort, setIsMobileViewPort] = useState(portSize === 'mobile' || portSize === 'tablet');
  const hidePrice = props?.isPackageBundle;

  useEffect(() => {
    function handleResize() {
      // eslint-disable-next-line react-hooks/rules-of-hooks, react-hooks/exhaustive-deps
      portSize = useGetBreakpoint();
      setIsMobileViewPort(portSize === 'mobile' || portSize === 'tablet');
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getDietList = () =>
    props?.item?.suitableDiets &&
    props?.item?.suitableDiets?.length > 0 &&
    props?.item?.suitableDiets?.map((diet: Diet) => (
      <DietAllergenIcon itemCode={diet.code} itemType={dietType} key={diet.name} />
    ));

  const getAllergenList = () =>
    props?.item?.allergens &&
    props?.item?.allergens?.length > 0 &&
    props?.item?.allergens?.map((allergen: Allergen) => (
      <DietAllergenIcon itemCode={allergen.code} itemType={allergenType} key={allergen.name} />
    ));

  const getBundleItem = () => {
    // const itemName =
    //   props?.item?.name <= sectionNameLimit ? props?.item?.name : props?.item?.name?.slice(0, sectionNameLimit);
    return (
      <StyledBundleContainer className="d-flex justify-content-between align-items-center" key={props?.item?.name}>
        {props?.item?.name && (
          <span className={clsx(isMobileViewPort ? 't-label-s' : 't-subtitle-m')}>{props?.item?.name}</span>
        )}
        {props?.item?.priceWithCurrency && (
          <span className={clsx(isMobileViewPort ? 't-label-xs' : 't-label-s', 'item-price')}>
            {props?.item?.priceWithCurrency}
          </span>
        )}
      </StyledBundleContainer>
    );
  };

  const getAddonItem = () => {
    // const itemName =
    //   props?.item?.name <= itemBundleNameLimit ? props?.item?.name : props?.item?.name?.slice(0, itemBundleNameLimit);

    return (
      <StyledAddonContainer
        className="d-flex justify-content-between align-items-baseline"
        calories={props?.item?.calories || ''}
        key={props?.item?.name}
      >
        <div className="addon-name">
          {props?.item?.name && (
            <span className={clsx(isMobileViewPort ? 't-font-xs' : 't-font-s')}>
              {props?.addOn}
              {props?.item?.name}
            </span>
          )}
          {((props && props?.item?.suitableDiets && props?.item?.suitableDiets?.length > 0) ||
            (props && props?.item?.allergens && props?.item?.allergens?.length > 0)) && (
            <div className="diet-allergen-codes-info d-flex flex-row flex-wrap">
              {getDietList()}
              {getAllergenList()}
            </div>
          )}
        </div>
        {props?.item?.calories && (
          <span className="t-label-xs">
            {props?.item?.caloriesUnit}: {props?.item?.calories}
          </span>
        )}
        {!hidePrice && props?.item?.priceWithCurrency && (
          <span className={clsx(isMobileViewPort ? 't-label-xs' : 't-label-s', 'item-price')}>
            +{props?.item?.priceWithCurrency}
          </span>
        )}
      </StyledAddonContainer>
    );
  };

  const getSectionItem = () => {
    return (
      <StyledSectionItemMain className="d-flex flex-column px-md-5 px-lg-5 px-xl-5 ml-1">
        <StyledSectionItemContainer
          className="d-flex justify-content-between align-items-baseline"
          calories={props?.item?.calories || ''}
          key={props?.item?.name}
        >
          <div className={clsx('section-item-container text-left')}>
            <span className={clsx(isMobileViewPort ? 't-subtitle-m' : 't-subtitle-l col-md-12 pl-0')}>
              {props?.item?.name
                ? props?.item?.name?.length > sectionNameMenuLimit
                  ? props?.item?.name?.slice(0, sectionNameMenuLimit) + '...'
                  : props?.item?.name
                : null}
            </span>
            <div className="col-md-12 pl-0">
              {' '}
              <p className="t-font-xs mb-1 mt-1">
                {props?.item?.description
                  ? props?.item?.description?.length > sectionDescriptionLimit
                    ? props?.item?.description?.slice(0, sectionDescriptionLimit) + '...'
                    : props?.item?.description
                  : null}
              </p>{' '}
            </div>
            <div className="diet-allergen-codes-info d-flex flex-row flex-wrap">
              {getDietList()}
              {getAllergenList()}
            </div>
          </div>
          {props?.item?.calories && (
            <span className="t-label-xs">
              {props?.item?.caloriesUnit}: {props?.item?.calories}
            </span>
          )}
          {!hidePrice && props?.item?.priceWithCurrency && (
            <span className={clsx(isMobileViewPort ? 't-label-xs' : 't-label-s', 'item-price')}>
              {props?.item?.priceWithCurrency}
            </span>
          )}
        </StyledSectionItemContainer>
        {props?.item?.itemBundles?.package &&
          props?.item?.itemBundles?.package.map((packageItem: any) => (
            <MenuDetailsItem
              item={packageItem}
              itemType={itemBundle}
              key={packageItem?.name}
              isPackageBundle={hidePrice}
            />
          ))}
        {props?.item?.itemBundles?.addons &&
          props?.item?.itemBundles?.addons.map((addonItem: any) => (
            <MenuDetailsItem
              item={addonItem}
              itemType={addonItem}
              key={addonItem?.name}
              isPackageBundle={hidePrice}
              addOn={props?.addOn}
            />
          ))}
      </StyledSectionItemMain>
    );
  };

  const getItemBundle = () => {
    // const itemName =
    //   props?.item?.name <= itemBundleNameLimit ? props?.item?.name : props?.item?.name?.slice(0, itemBundleNameLimit);

    return (
      <StyledSectionItemContainer
        className="d-flex justify-content-between align-items-baseline"
        calories={props?.item?.calories || ''}
        key={props?.item?.name}
      >
        <div className={clsx('section-item-container text-left')}>
          {props?.item?.name && (
            <span className={clsx(isMobileViewPort ? 't-font-xs' : 't-font-s col-md-12 pl-0')}>
              {props?.item?.name}
            </span>
          )}
          <div className="diet-allergen-codes-info d-flex flex-row flex-wrap">
            {getDietList()}
            {getAllergenList()}
          </div>
        </div>
        {props?.item?.calories && (
          <span className="t-label-xs">
            {props?.item?.caloriesUnit}: {props?.item?.calories}
          </span>
        )}
        {!hidePrice && props?.item?.priceWithCurrency && (
          <span className={clsx(isMobileViewPort ? 't-label-xs' : 't-label-s', 'item-price')}>
            {props?.item?.priceWithCurrency}
          </span>
        )}
      </StyledSectionItemContainer>
    );
  };

  return props?.itemType === packageBundle || props?.itemType === sectionBundle
    ? getBundleItem()
    : props?.itemType === sectionItem
    ? getSectionItem()
    : props?.itemType === addonItem
    ? getAddonItem()
    : props?.itemType === itemBundle
    ? getItemBundle()
    : null;
};

export default MenuDetailsItem;
